import React from 'react';
import './ShippingMethod.css';
import { useSelector, useDispatch } from 'react-redux';
import { setCheckoutStep } from '../../../actions/actionCreators';

const AddressPicker = (props) => {
  const cart = useSelector(state => state.cartReducer);
  const mainColor = useSelector(state => state.frontConfigReducer.color);
  const dispatch = useDispatch();

  //Change address in previous step
  const changeAddress = () => {
    dispatch(setCheckoutStep(1));
  }

  return (
    <div className='AddressPickerContainer'>
      <div className='PrefilledAddressContainer'>
        <p className='BoldAddress'>{cart.shipping_address.address1}</p>
        <p className='AddressText'>{cart.shipping_address.city}, {cart.shipping_address.state_code ? cart.shipping_address.state_code : cart.shipping_address.province_code} {cart.shipping_address.zip}</p>
      </div>
      <div className='EditAddressBtnContainer'>
        <button style={{ backgroundColor: mainColor }} className='EditAddressBtn' onClick={changeAddress}>Edit address</button>
      </div>
    </div>
  )
}

export default AddressPicker;